import { MenuItem } from "./menu.model";

//FOR SUPERADMIN ONLY
export const MENU: MenuItem[] = [
  {
    id: 1,
    label: "Financial Analysis",
    isTitle: true,
  },
  {
    id: 2,
    label: "Dashboard",
    icon: "bx-home-circle",
    link: "/dashboard",
  },
  {
    id: 3,
    isLayout: true,
  },
  {
    id: 4,
    label: "Financial Data",
    icon: "bx bx-line-chart",
    subItems: [
      {
        id: 5,
        label: "- Annual Reports",
        icon: "bxs-report",
        link: "/tables/finance",
      },
      {
        id: 6,
        label: "- Segment Info",
        icon: "bxs-report",
        link: "/tables/segmentinfo",
      },
    ],
  },
  {
    id: 7,
    label: "Clustering",
    icon: "bx bx-cube",
    link: "/tables/playground",
  },
  {
    id: 8,
    label: "Market Analysis",
    isTitle: true,
  },
  {
    id: 10,
    label: "Competitors",
    icon: "bx bx-chart",
    link: "/competitoranalysis",
  },
  // {
  //   id: 10,
  //   label: "Sunway Analysis",
  //   icon: "bx bx-chart",
  //   link: "/sunwaymarket",
  // },
  {
    id: 11,
    label: "RF Reporting",
    isTitle: true,
  },
  {
    id: 9,
    label: "BP Progress",
    icon: "bx bx-briefcase",
    link: "/businessplan",
    badge: {
      variant: "success",
      text: "2025",
    },
  },
  {
    id: 12,
    label: "Rolling Forecast",
    icon: "bx-bar-chart",
    link: "/rfdashboard",
    badge: {
      variant: "success",
      text: "Group",
    },
  },
  {
    id: 13,
    label: "Rolling Forecast",
    icon: "bx bx-analyse",
    link: "/rollingforecast",
    badge: {
      variant: "success",
      text: "Company",
    },
  },
  {
    id: 14,
    label: "Department Expenses",
    isTitle: true,
  },
  {
    id: 15,
    label: "Cost Analysis",
    icon: "bx bx-bar-chart-alt-2",
    link: "/deptexpenses",
  },
  {
    id: 16,
    label: "Cost Report",
    icon: "bx bx-line-chart",
    link: "/deptexpfull",
  },
  {
    id: 17,
    label: "User Management",
    isTitle: true,
  },
  {
    id: 18,
    label: "All Users",
    icon: "bx bx-user",
    link: "/contacts/list",
    parentId: 15,
  },
  {
    id: 19,
    label: "User logs",
    icon: "bx bxs-report",
    link: "/contacts/userlogs",
    parentId: 15,
  },
];

//FOR CFO OFFICE ONLY
export const MENU1: MenuItem[] = [
  {
    id: 1,
    label: "Financial Analysis",
    isTitle: true,
  },

  {
    id: 2,
    label: "Dashboard",
    icon: "bx-home-circle",
    link: "/dashboard",
  },
  {
    id: 3,
    isLayout: true,
  },
  {
    id: 4,
    label: "Financial Data",
    icon: "bx bx-line-chart",
    subItems: [
      {
        id: 5,
        label: "- Annual Reports",
        icon: "bxs-report",
        link: "/tables/finance",
      },
      {
        id: 6,
        label: "- Segment Info",
        icon: "bxs-report",
        link: "/tables/segmentinfo",
      },
    ],
  },
  {
    id: 7,
    label: "Clustering",
    icon: "bx bx-cube",
    link: "/tables/playground",
  },
  {
    id: 8,
    label: "Business Plans",
    isTitle: true,
  },
  {
    id: 9,
    label: "BP Progress",
    icon: "bx bx-briefcase",
    link: "/businessplan",
    badge: {
      variant: "success",
      text: "2025",
    },
  },
  {
    id: 10,
    label: "Competitors",
    icon: "bx bx-chart",
    link: "/competitoranalysis",
  },
  {
    id: 11,
    label: "RF Reporting",
    isTitle: true,
  },
  {
    id: 12,
    label: "Rolling Forecast",
    icon: "bx-bar-chart",
    link: "/rfdashboard",
    badge: {
      variant: "success",
      text: "Group",
    },
  },
  {
    id: 143,
    label: "Rolling Forecast",
    icon: "bx bx-analyse",
    link: "/rollingforecast",
    badge: {
      variant: "success",
      text: "Company",
    },
  },
  {
    id: 14,
    label: "Department Cost",
    isTitle: true,
  },
  {
    id: 15,
    label: "Cost Analysis",
    icon: "bx bx-bar-chart-alt-2",
    link: "/deptexpenses",
  },
  {
    id: 16,
    label: "Cost Report",
    icon: "bx bx-line-chart",
    link: "/deptexpfull",
  },
];

//FOR MARKET ANALYSIS COMPETITORS
export const MENU2: MenuItem[] = [
  {
    id: 1,
    label: "Financial Analysis",
    isTitle: true,
  },
  {
    id: 2,
    label: "Dashboard",
    icon: "bx-home-circle",
    link: "/dashboard",
  },
  {
    id: 3,
    isLayout: true,
  },
  {
    id: 4,
    label: "Financial Data",
    icon: "bx bx-line-chart",
    subItems: [
      {
        id: 5,
        label: "- Annual Reports",
        icon: "bxs-report",
        link: "/tables/finance",
      },
      {
        id: 6,
        label: "- Segment Info",
        icon: "bxs-report",
        link: "/tables/segmentinfo",
      },
    ],
  },
  {
    id: 7,
    label: "Market Analysis",
    isTitle: true,
  },
  {
    id: 8,
    label: "Competitors",
    icon: "bx bx-chart",
    link: "/competitoranalysis",
  },
];

//FOR FINANCE EMPLOYEES
export const MENU3: MenuItem[] = [
  {
    id: 1,
    label: "Financial Analysis",
    isTitle: true,
  },

  {
    id: 2,
    label: "Dashboard",
    icon: "bx-home-circle",
    link: "/dashboard",
  },
  {
    id: 3,
    isLayout: true,
  },
  {
    id: 4,
    label: "Financial Data",
    icon: "bx bx-line-chart",
    subItems: [
      {
        id: 5,
        label: "- Annual Reports",
        icon: "bxs-report",
        link: "/tables/finance",
      },
      {
        id: 6,
        label: "- Segment Info",
        icon: "bxs-report",
        link: "/tables/segmentinfo",
      },
    ],
  },
];

//FOR ADMINS
export const MENU4: MenuItem[] = [
  {
    id: 1,
    label: "Financial Analysis",
    isTitle: true,
  },
  {
    id: 2,
    label: "Dashboard",
    icon: "bx-home-circle",
    link: "/dashboard",
  },
  {
    id: 3,
    isLayout: true,
  },
  {
    id: 4,
    label: "Financial Data",
    icon: "bx bx-line-chart",
    subItems: [
      {
        id: 5,
        label: "- Annual Reports",
        icon: "bxs-report",
        link: "/tables/finance",
      },
      {
        id: 6,
        label: "- Segment Info",
        icon: "bxs-report",
        link: "/tables/segmentinfo",
      },
    ],
  },
  {
    id: 7,
    label: "Clustering",
    icon: "bx bx-cube",
    link: "/tables/playground",
  },
  {
    id: 8,
    label: "Business Plans",
    isTitle: true,
  },
  {
    id: 9,
    label: "BP Progress",
    icon: "bx bx-briefcase",
    link: "/businessplan",
    badge: {
      variant: "success",
      text: "2025",
    },
  },
  {
    id: 10,
    label: "Competitors",
    icon: "bx bx-chart",
    link: "/competitoranalysis",
  },

  {
    id: 11,
    label: "RF Reporting",
    isTitle: true,
  },
  {
    id: 12,
    label: "Rolling Forecast",
    icon: "bx-bar-chart",
    link: "/rfdashboard",
    badge: {
      variant: "success",
      text: "Group",
    },
  },
  {
    id: 13,
    label: "Rolling Forecast",
    icon: "bx bx-analyse",
    link: "/rollingforecast",
    badge: {
      variant: "success",
      text: "Company",
    },
  },
  {
    id: 14,
    label: "Department Expenses",
    isTitle: true,
  },
  {
    id: 15,
    label: "Cost Analysis",
    icon: "bx bx-bar-chart-alt-2",
    link: "/deptexpenses",
  },
  {
    id: 16,
    label: "Cost Report",
    icon: "bx bx-line-chart",
    link: "/deptexpfull",
  }
];

// 3X DASHBOARD
//DEMO
// {
//   id: 1,
//   label: "ESSA DEMO",
//   isTitle: true,
// },
// {
//   id: 2,
//   label: "Report Analysis",
//   icon: "bx-home-circle",
//   link: "/3xdashboardbu",
// },
// {
//   id: 2,
//   label: "Overview",
//   icon: "bx-home-circle",
//   link: "/3xdashboard",
// },
// {
//   id: 2,
//   label: "Report",
//   icon: "bx-home-circle",
//   link: "/3xreportsbu",
// },
//END DEMO

// {
//   id: 8,
//   label: "RF Analysis",
//   icon: "bx-bar-chart",
//   link: "/rfanalysis",
// },
// {
//   id: 9,
//   label: "Submit Report",
//   icon: "bx bxs-report",
//   link: "/submitrf",
// },

// {
//   id: 10,
//   label: "Business Plans",
//   isTitle: true,
// },
// {
//   id: 11,
//   label: "Business Plans",
//   icon: "bx bx-analyse",
//   link: '/businessplans',
// },
// {
//   id: 12,
//   label: "Submit BP",
//   icon: "bx bxs-report",
//   link: "/submitbp",
// },

//FOR RF REPORTERS
// export const MENU2: MenuItem[] = [
//   {
//     id: 1,
//     label: "Financial Analysis",
//     isTitle: true,
//   },
//   {
//     id: 2,
//     label: "Dashboard",
//     icon: "bx-home-circle",
//     link: "/dashboard",
//   },
//   {
//     id: 3,
//     isLayout: true,
//   },
//   {
//     id: 4,
//     label: "Financial Data",
//     icon: "bx bx-line-chart",
//     subItems: [
//       {
//         id: 5,
//         label: "- Annual Reports",
//         icon: "bxs-report",
//         link: "/tables/finance",
//       },
//       {
//         id: 6,
//         label: "- Segment Info",
//         icon: "bxs-report",
//         link: "/tables/segmentinfo",
//       },
//     ],
//   },

//   {
//     id: 7,
//     label: "RF Reporting",
//     isTitle: true,
//   },
//   {
//     id: 9,
//     label: "Submit Report",
//     icon: "bx bxs-report",
//     link: "/submitrf",
//   },

//   {
//     id: 10,
//     label: "Business Plans",
//     isTitle: true,
//   },
//   {
//     id: 11,
//     label: "Business Plans",
//     icon: "bx bx-analyse",
//   },
// ];
